import { cn } from '@/lib/utils';

interface PlanToggleProps {
  isAnnual: boolean;
  onToggle: (annual: boolean) => void;
  className?: string;
}

export function PlanToggle({ isAnnual, onToggle, className }: PlanToggleProps) {
  return (
    <div className={cn('flex items-center justify-center gap-3', className)}>
      <button
        onClick={() => onToggle(false)}
        className={cn(
          'px-4 py-2 text-sm font-medium rounded-lg transition-colors',
          !isAnnual
            ? 'bg-primary text-primary-foreground'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        Monthly
      </button>
      <button
        onClick={() => onToggle(true)}
        className={cn(
          'px-4 py-2 text-sm font-medium rounded-lg transition-colors',
          isAnnual
            ? 'bg-primary text-primary-foreground'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        Annual
        <span className="ml-1.5 text-xs font-normal opacity-80">Save 16%</span>
      </button>
    </div>
  );
}
